export const roleEnum = {
    B2C_ORGANIZATION: "b2c_organization",
    B2C_INDIVIDUAL: "b2c_individual",
    PERKESO_USER: "perkeso"
};
